import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const knowledgeHubBrowseAllArticlesRoute: InvariantJiraRoute = {
	name: 'knowledge-hub-browse-all-articles',
	path: '/jira/servicedesk/projects/:projectKey/knowledge/articles',
	exact: true,
};
